module.exports = __webpack_public_path__ + "static/media/stairs.9f10dab5.jpg";